import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Menu, Drawer, notification,
} from 'antd';
import { H3_TITLE } from '@Apis/constants';
import { Helmet } from 'react-helmet';
import './style.scss';
import PropTypes from 'prop-types';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import TenantActions from '@Actions/tenantActions';
import H3Text from '@Uilib/h3Text';
import {
  CloseOutlined,
} from '@ant-design/icons';
import TenantForm from '@Components/Common/TenantForm';
import CreateTenant from '@Components/Common/CreateTenant';
import UpdateTenant from '@Components/Common/UpdateTenant';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import BusinessUnitOverview from '../BusinessUnitOverview';
import BusinessUnitProductsList from '../BusinessUnitProductsList';
import BusinessTransactionsList from '../BusinessTransactionsList';
/**
 *
 */
class BusinessUnitDetails extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      rolecolumns: [
        {
          title: '',
          render: (text, record) => {
            const { changeTenant } = this.props;
            return (
              <div
                className="tenant__box"
                onClick={() => {
                  changeTenant(record);
                }}
              >
                <H3Text text={`${record.tenant_name ? record.tenant_name : ''}`} className="tenant__name" />
                <H3Text text={record?.default_billing_address_info?.city ? `${record?.default_billing_address_info?.city}, ${record?.default_billing_address_info?.state}` : '-'} className="tenant__district" />

              </div>
            );
          },
        },

      ],
      showNewRoleModal: false,
      showUpdateRoleModal: false,
      currentPage: '/overview',
      users: [],
    };
  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @return
   */
  static getDerivedStateFromProps(props, state) {
    if (props?.tenants) {
      const array = props?.tenants?.tenant?.filter(
        (item) => item?.tenant_id === props?.user?.tenant_info?.tenant_id,
      );
      const users = array?.[0]?.tenant_users;
      const uniqueRoles = [];
      for (let i = 0; i < users?.length; i++) {
        if (!uniqueRoles.includes(users[i].role_id)) {
          uniqueRoles.push(users[i].role_id);
        }
      }
      return {
        ...state,
        users: array?.[0]?.tenant_users,
        uniqueRoles,
      };
    }
    return state;
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      user, getTenantsLoading, tenants, onClose, selectedTenant, getTenants, changeTenant,
    } = this.props;
    const {
      rolecolumns, currentPage, showNewTenantModal, showUpdateTenantModal,
      showAddProductModal,
    } = this.state;
    const subscription = user?.tenant_info?.global_config?.settings;

    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{H3_TITLE}</title>
        </Helmet>
        <Drawer
          open={showNewTenantModal}
          onClose={() => this.setState({ showNewTenantModal: false })}
          width="600px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header">
              <H3Text text="Create New Business Unit" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showNewTenantModal: false })} />
            </div>
          </div>
          <TenantForm
            callback={() => {
              this.setState({ showNewTenantModal: false });
              getTenants(1, '', true, user?.tenant_info?.org_id, '', () => { });
            }}
          />
        </Drawer>
        <Drawer
          open={showUpdateTenantModal}
          width="600px"
          mask
          onClose={() => this.setState({ showUpdateTenantModal: false })}
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header">
              <H3Text text={`Update Business Unit #${selectedTenant?.tenant_id}`} className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showUpdateTenantModal: false })} />
            </div>
          </div>
          <TenantForm
            selectedTenant={selectedTenant}
            callback={() => {
              this.setState({ showUpdateTenantModal: false });
              getTenants(1, '', true, user?.tenant_info?.org_id, '', (tenantData) => {
                changeTenant(tenantData?.data?.filter((item) => item?.tenant_id === selectedTenant?.tenant_id)?.[0]);
              });
            }}
          />
        </Drawer>

        <div className="business-unit-details__wrapper">
          <div className="ant-row">
            <div className="ant-col-md-6">
              <div className="businessDetail-table-container hide__in-mobile">
                <Table
                  title={() => (
                    <div className="business-unit-details__table-header">
                      {`${tenants?.data?.length || '0'} Business Units`}
                      <H3Button
                        buttonType={defaultButtonTypes.BLUE_ROUNDED}
                        text="+ Add"
                        onClick={() => {
                          if (tenants?.data?.length >= subscription?.business_unit_limit) {
                            notification.error({
                              message: `Please upgrade your subscription. You have an active subscription of ${subscription?.business_unit_limit} business units only.`,
                              placement: 'top',
                              duration: 4,
                            });
                          } else {
                            this.setState({ showNewTenantModal: true });
                          }
                        }}
                        customClass="business-unit-details__table-add-button"
                      />

                    </div>
                  )}
                  showHeader={null}
                  loading={getTenantsLoading}
                  size="small"
                  columns={rolecolumns}
                  dataSource={tenants?.data || []}
                  currentPage
                  pagination={false}
                  rowClassName={(record) => (record.tenant_id === Number(selectedTenant.tenant_id) ? 'selected__tenant' : '')}
                />
              </div>
            </div>
            <div className="ant-col-md-18">
              <div className="businessDetail__tenant-detail">
                <div className="businessDetail__tenant-detail-header-wrapper-outer">
                  <div className="businessDetail__tenant-detail-header-wrapper">
                    <div className="businessDetail__tenant-detail-header">
                      <div>
                        {`${selectedTenant?.tenant_name}`}
                      </div>
                      <div onClick={() => onClose()}>
                        <CloseOutlined />
                      </div>
                    </div>
                    <Menu
                      selectedKeys={[currentPage.toString()]}
                      defaultSelectedKeys={['/overview']}
                      onClick={(value) => {
                        this.setState({ currentPage: value.key });
                      }}
                      mode="horizontal"
                    >
                      <Menu.Item key="/overview">
                        Overview
                      </Menu.Item>
                      <Menu.Item key="/inventory">
                        Inventory
                      </Menu.Item>
                      <Menu.Item key="/transactions">
                        Transactions
                      </Menu.Item>
                      <Menu.Item disabled key="/purchase-ledger">
                        Purchase Ledger
                      </Menu.Item>
                    </Menu>
                  </div>
                </div>
                <div style={{ marginTop: '25px', marginLeft: '15px' }}>
                  {currentPage === '/overview' && (
                    < BusinessUnitOverview
                      selectedTenant={selectedTenant}
                      showUpdateTenantModal={() => this.setState({ showUpdateTenantModal: true })}
                    />
                  )}
                  {currentPage === '/inventory' && (
                    <BusinessUnitProductsList
                      disableHeader
                      selectedTenant={selectedTenant}
                      showAddProductModal={showAddProductModal}
                      closeNewProductModal={() => this.setState({ showAddProductModal: false })}
                    />
                  )}
                  {currentPage === '/transactions' && (
                    <BusinessTransactionsList
                      selectedTenant={selectedTenant}
                    />
                  )}

                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, TenantReducers,
}) => ({
  user: UserReducers.user,
  users: TenantReducers.users,
  tenants: TenantReducers.tenants,
  getTenantsLoading: TenantReducers.getTenantsLoading,
  getUsersLoading: UserReducers.getUsersLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getUsers: (tenantId, roleId) => dispatch(TenantActions.getUsers(tenantId, roleId)),
  getTenants: (page, keyword, isVerified, orgId, limit, callback) => dispatch(
    TenantActions.getTenants(page, keyword, isVerified, orgId, limit, callback),
  ),
});

BusinessUnitDetails.propTypes = {
  user: PropTypes.func,
  tenants: PropTypes.any,
  getTenantsLoading: PropTypes.bool,
  onClose: PropTypes.func,
  selectedTenant: PropTypes.any,
  changeTenant: PropTypes.func,
  getTenants: PropTypes.func,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BusinessUnitDetails));
